import React from 'react';
import ServiceCard from '../../common/ServiceCard';
import pensionPlans from '../../../assets/images/home/pension-plans-insurance.webp';
import bankingInvestments from '../../../assets/images/home/banking-investments.webp';
import consumerFinance from '../../../assets/images/home/consumer-finance.webp';

const services = [
  {
    title: 'Pension Plans & Insurance',
    description: "Secure your future with pension plans from Ghana's leading providers...",
    image: pensionPlans,
    hasGradient: true,
    isReversed: false,
  },
  {
    title: 'Banking & Investments',
    description: "Access the best savings accounts and loan options from Ghana's trusted institutions...",
    image: bankingInvestments,
    hasGradient: false,
    isReversed: true,
  },
  {
    title: 'Consumer Finance Options & Micro Loan Services',
    description: "Make major purchases manageable with consumer financing options...",
    image: consumerFinance,
    hasGradient: true,
    isReversed: false,
  }
];

export default function Services() {
  return (
    <div className="bg-white">
      {services.map((service, index) => (
        <ServiceCard
          key={index}
          showHeading={index === 0} // Show heading only in the first section
          {...service}
        />
      ))}
    </div>
  );
}
